export class UpdateOrganizationIdpResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idp",
            "baseName": "idp",
            "type": "OrganizationIdp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateOrganizationIdpResponse.attributeTypeMap;
    }
    constructor() {
    }
}
